export default "__VITE_ASSET__CsrKPuEp__"